import { render, staticRenderFns } from "./DeliveryEstablishment.vue?vue&type=template&id=5c711e68"
import script from "./DeliveryEstablishment.vue?vue&type=script&lang=js"
export * from "./DeliveryEstablishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports